import { render, staticRenderFns } from "./RsaPazienteAttivitaObiettiviModalComponent.vue?vue&type=template&id=2ae97d2f&scoped=true"
import script from "./RsaPazienteAttivitaObiettiviModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAttivitaObiettiviModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae97d2f",
  null
  
)

export default component.exports